import React from 'react'
import Edit from '../features/editor/Edit'

function EditPage() {
  return (
    <div>
        <Edit />
    </div>
  )
}

export default EditPage